"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = void 0;
var react_1 = __importDefault(require("react"));
var techsee_base_component_1 = require("../../../_shared/techsee-base-component");
var index_1 = require("../generic/index");
var SecondaryButton = (function (_super) {
    __extends(SecondaryButton, _super);
    function SecondaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecondaryButton.prototype.renderInternal = function () {
        return (react_1.default.createElement(index_1.GenericButton, __assign({}, this.props, { buttonType: index_1.ButtonTypes.Secondary }), this.props.children));
    };
    return SecondaryButton;
}(techsee_base_component_1.TechseeBaseComponent));
exports.SecondaryButton = SecondaryButton;
